import React, { Component } from 'react'; 
import { AuthContext } from '../../../auth/AuthHandler';
import { BackButton, VersionCard, Switcher, TitleCard } from '../../../components/index';
import { ReleaseTrackerDataService, softwareIdToName } from '../../../data/ReleaseTrackerDataService';
import './Versions.css';


export default class Versions extends Component{

  static contextType = AuthContext

  constructor(props){
    super(props);
    this.state = {
      show: false, 
      key: '', 
      selected: false,
      selectedItem: ''
    }
    this.getVersions = this.getVersions.bind(this)
  }

  componentDidMount() {
    this.relTrackerService = new ReleaseTrackerDataService(this.context);

    const { url } = this.props.match.params;
    this.relTrackerService.getSoftwarePackage(softwareIdToName(url))
      .then(data => {
        this.setState({
          softwarePackage: data,
          softwareVersions: [],
        }, () => {
          // select first by default
          if (this.state.softwarePackage.MayorVersions && this.state.softwarePackage.MayorVersions.length > 0) {
            this.getVersions(this.state.softwarePackage.MayorVersions[0])
          }
        })
      })
      .catch(err => {
        console.error(err);
      });

  }

  getVersions(key) {
    const { url } = this.props.match.params;
    this.setState({
      softwareVersions: [],
      selected: true,
      show: true,
      key: key,
      selectedItem: 'V'+key.MayorVersion,
    })

    // download version details
    this.relTrackerService.getSoftwareVersions(softwareIdToName(url), key.MayorVersion)
      .then(data => {
        this.setState({
          softwareVersions: data,
          selected: true,
          show: true,
          key: key,
          selectedItem: 'V'+key.MayorVersion,
        })
      })
      .catch(err => {
        console.error(err);
      });

  }

  render() {
    const { url } = this.props.match.params;

    return (
      <div className="versions">
        <BackButton />
        <div className="titleSection">
          <TitleCard img={require('./../../../assets/svg/'+url+'.svg').default} />
          {this.state.softwarePackage && 
            <div>
              <h3>{this.state.softwarePackage.Name}</h3>
              <p>Select version</p>
            </div>
          }
        </div>
        <div className="switcher">
        {this.state.softwarePackage && 
          this.state.softwarePackage.MayorVersions.map((key, index) => (
            <Switcher 
              key={key.MayorVersion} 
              content={"V"+key.MayorVersion}
              selected={this.state.selected}
              selectedItem={this.state.selectedItem}
              // onFocus={() => key[0].MayorVersion}
              onClick={() => this.getVersions(key)}/>
          ))
        }
        </div>
        
        {this.state.show && 
          <div className="cards">
            {this.state.softwareVersions.map(value => 
              <VersionCard key={value.Code} title={value.Code} version={{pathname:'/software/'+url+'/'+this.state.key.MayorVersion+'/'+value.Code}}/>
            )}
          </div>
        } 
      </div>
    )
  }
}
